import { transport } from 'config/transport';

export function callApiSaveHolidaysOfClass(classId, month, dayOffs) {
    return transport.post(`/mamnon/classes/${classId}/holidays`, { holidayMonth: month, dayOffs });
}
